// extracted by mini-css-extract-plugin
module.exports = {"userOptin":"userOptin__3_q7g"};